import { render, staticRenderFns } from "./InactiveFlag.vue?vue&type=template&id=36f869ad&scoped=true"
import script from "./InactiveFlag.vue?vue&type=script&lang=js"
export * from "./InactiveFlag.vue?vue&type=script&lang=js"
import style0 from "./InactiveFlag.vue?vue&type=style&index=0&id=36f869ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f869ad",
  null
  
)

export default component.exports